import React, { FunctionComponent } from 'react';

import { i18n } from 'src/i18n';
import { arrowLeftWhiteImageProps, logoHorizontalImageProps, logoVerticalImageProps } from 'src/resources/images';
import { AuthenticationService } from 'src/services/authentication-service';
import { selectIsAuthenticated } from 'src/state/auth/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { useLargeTabletMediaQuery } from 'src/utils/breakpoints-utils';
import { Image } from 'src/components/image';
import { config } from 'src/config/config';

import {
  StyledHeader,
  StyledHeaderContainer,
  StyledLink,
  StyledLinkText,
  StyledLogo,
  StyledLogoutButton,
} from './header.styled';

export const Header: FunctionComponent = () => {
  const loggedIn = useAppSelector(selectIsAuthenticated);
  const isOnLargeTablet = useLargeTabletMediaQuery();
  const logoProps = isOnLargeTablet ? logoHorizontalImageProps : logoVerticalImageProps;

  const handleLogout = () => {
    AuthenticationService.logout();
  };

  return (
    <StyledHeader>
      <StyledHeaderContainer>
        <StyledLink href={config.MAIN_PAGE_URL}>
          <Image {...arrowLeftWhiteImageProps} />
          <StyledLinkText variant="uiText3" component="p">
            {i18n.component.header.linkToMainPage}
          </StyledLinkText>
        </StyledLink>
        <StyledLogo {...logoProps} />
        {loggedIn && <StyledLogoutButton onClick={handleLogout}>{i18n.component.header.logout}</StyledLogoutButton>}
      </StyledHeaderContainer>
    </StyledHeader>
  );
};
